export interface NavItem {
  key: string;
  to: string;
  labelKey: string;
  icon: string;
}

export interface NavGroup {
  key: string;
  labelKey: string;
  items: NavItem[];
}

export const navGroups: NavGroup[] = [
  {
    key: 'main',
    labelKey: 'navGroup.main',
    items: [
      { key: 'home', to: '/dashboard', labelKey: 'nav.home', icon: 'ri-home-5-line' },
      { key: 'orders', to: '/dashboard/orders', labelKey: 'nav.orders', icon: 'ri-file-list-3-line' },
      { key: 'items', to: '/dashboard/items', labelKey: 'nav.items', icon: 'ri-shirt-line' },
      { key: 'drivers', to: '/dashboard/drivers', labelKey: 'nav.drivers', icon: 'ri-e-bike-2-line' },
      { key: 'finance', to: '/dashboard/finance', labelKey: 'nav.finance', icon: 'ri-wallet-3-line' },
      { key: 'reviews', to: '/dashboard/reviews', labelKey: 'nav.reviews', icon: 'ri-star-line' },
    ],
  },
  {
    key: 'management',
    labelKey: 'navGroup.management',
    items: [
      {
        key: 'notifications',
        to: '/dashboard/notifications',
        labelKey: 'nav.notifications',
        icon: 'ri-notification-3-line',
      },
      { key: 'settings', to: '/dashboard/settings', labelKey: 'nav.settings', icon: 'ri-settings-3-line' },
    ],
  },
];

// flat list kept for consumers that only need every item (e.g. the topbar title lookup)
export const navItems: NavItem[] = navGroups.flatMap((group) => group.items);